// Idle-timeout constants for the stylist web inactivity-logout feature.
// Defaults are used until /config/features returns remote values in FeatureFlagsContext.

/** Default idle timeout (minutes) — overridden by backend /config/features. */
export const DEFAULT_IDLE_TIMEOUT_MINUTES = 15;

/** Default warning lead time (minutes) — overridden by backend /config/features. */
export const DEFAULT_IDLE_WARNING_MINUTES = 2;

/** Total idle time (ms) before a stylist is logged out. */
export const IDLE_TIMEOUT_MS = DEFAULT_IDLE_TIMEOUT_MINUTES * 60 * 1000;

/** How many ms before timeout to show the warning modal. */
export const IDLE_PROMPT_BEFORE_MS = DEFAULT_IDLE_WARNING_MINUTES * 60 * 1000;

/** How often (ms) react-idle-timer syncs state across open tabs. */
export const IDLE_SYNC_INTERVAL_MS = 200;

/** Hard cap: any pause() request is force-released after this many ms. */
export const IDLE_PAUSE_HARD_CAP_MS = 30 * 60 * 1000; // 30 minutes
